import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import VueBase from '@/VueBase';
import { locales } from '@/i18n-setup';
import helper from '@/services/helper';
import Q from 'q';
import api from '@/services/api';
import VueRecaptcha from 'vue-recaptcha';

import SendPasswordModal from '@/components/Modals/SendPasswordModal.vue';
import swal from 'sweetalert2';

@Component({
  components: {
    SendPasswordModal,
  },
  computed: {
    ...mapState({
      Lang: 'Lang',
      ShowLanguages: 'ShowLanguages',
      CommitteeEmail: 'CommitteeEmail',
      CaptchaKey: 'CaptchaKey',
      ShowCaptcha: 'ShowCaptcha',
    }),
  },
})
export default class LoginMixins extends VueBase {
  public readonly ShowLanguages!: string;
  public readonly Lang!: string;
  public readonly CommitteeEmail!: string;
  public readonly CaptchaKey!: string;
  public readonly ShowCaptcha!: boolean;

  public Username: string = '';
  public showMsgWrongDates: boolean = true;
  public msgWrongDates: string = '';
  private tocken: string = '';

  get helpLink() {
    return `<a href="/#/help" target="_blank"><b class="underline">${this.$t('vs.login.contactuslink')}</b></a>`;
  }

  get inputPlaceholder() {
    if (this.Lang == 'he-IL') {
      if (process.env.VUE_APP_CLIENT == 'acb') {
        return "אנא הזן מספר ת.ז קבלן / נציג מוסמך";
      }
      if (process.env.VUE_APP_CLIENT == 'boi' || process.env.VUE_APP_CLIENT == 'dutyfree' || process.env.VUE_APP_CLIENT == 'ips') {
        return "אנא הזן מספר טלפון נייד";
      }
      if (process.env.VUE_APP_CLIENT == 'iai') {
        return "נא להזין מספר תעודת זהות+ספרת ביקורת";
      }
      if (process.env.VUE_APP_CLIENT == 'lsa') {
        return "אנא הזן מס' רישיון טיס";
      }
      if (process.env.VUE_APP_CLIENT == 'eitan') {
        return 'נא להזין 5 ספרות אחרונות של תעודת הזהות';
      }
      if (process.env.VUE_APP_CLIENT == 'medtau') {
        return 'אנא הזן מספר נייד (ללא מקף)';
      }
      if (process.env.VUE_APP_CLIENT == 'vaadaluma') {
        return 'אנא הזן מספר טלפון נייד ללא 0 תחילה';
      }
      if (process.env.VUE_APP_CLIENT == 'hakalkala') {
        return 'אנא הזן מס\' נייד';
      }
      
      
      if (
        process.env.VUE_APP_CLIENT == 'idf' ||
        process.env.VUE_APP_CLIENT == 'ariel' ||
        process.env.VUE_APP_CLIENT == 'teldor' ||
        process.env.VUE_APP_CLIENT == 'vaadgalil' ||
        process.env.VUE_APP_CLIENT == 'vaadmehandesim' ||
        process.env.VUE_APP_CLIENT == 'rupin' ||
        process.env.VUE_APP_CLIENT == 'cpa' ||
        process.env.VUE_APP_CLIENT == 'bait' || 
        (process.env.VUE_APP_CLIENT == 'mfa' && process.env.VUE_APP_THEME == '2022') ||
        process.env.VUE_APP_CLIENT == 'vaadminhalibiu' ||
        process.env.VUE_APP_CLIENT == 'mof' ||
        process.env.VUE_APP_CLIENT == 'vetvoting' ||
        process.env.VUE_APP_CLIENT == 'colmanvote' ||
        process.env.VUE_APP_CLIENT == 'akum' ||
        process.env.VUE_APP_CLIENT == 'igudyoatzot' ||
        process.env.VUE_APP_CLIENT == 'cultureministry' ||
        process.env.VUE_APP_CLIENT == 'tourism' ||
        process.env.VUE_APP_CLIENT == 'ministryofjustice' ||
        process.env.VUE_APP_CLIENT == 'eggedheseim' ||
        process.env.VUE_APP_CLIENT == 'acum'
      ) {
        return 'אנא הזן מספר ת״ז';
      }
      if (
        process.env.VUE_APP_CLIENT == 'strausswater' ||
        (process.env.VUE_APP_CLIENT == 'menora' && (process.env.VUE_APP_THEME == '2021' || process.env.VUE_APP_THEME == '20250729')) ||
        process.env.VUE_APP_CLIENT == 'kanvaad' ||
        process.env.VUE_APP_CLIENT == 'siidirector' ||
        process.env.VUE_APP_CLIENT == 'taasuka' ||
        process.env.VUE_APP_CLIENT == 'mizrahi' ||
        process.env.VUE_APP_CLIENT == 'bankleumi'
      ) {
        return 'אנא הזן מספר עובד';
      }
      if (process.env.VUE_APP_CLIENT == 'football'
        || process.env.VUE_APP_CLIENT == 'vaadrevaha'
        || process.env.VUE_APP_CLIENT == 'gimlaimmod'
        || process.env.VUE_APP_CLIENT == 'ashdodport'
        || process.env.VUE_APP_CLIENT == 'court'
        || process.env.VUE_APP_CLIENT == 'iaa'
        || process.env.VUE_APP_CLIENT == 'jwpe'
        || process.env.VUE_APP_CLIENT == 'insurance') {
        return 'אנא הזן מספר ת.ז.';
      }
      if (process.env.VUE_APP_CLIENT == 'igudteufa') {
        return 'אנא הזן מספר רישיון טיס';
      }
      if (process.env.VUE_APP_CLIENT == 'reichman') {
        return 'אנא הזן מספר זיהוי';
      }
    }
    if (
      process.env.VUE_APP_CLIENT == 'menora' ||
      process.env.VUE_APP_CLIENT == 'mfa' ||
      process.env.VUE_APP_CLIENT == 'milgam' ||
      process.env.VUE_APP_CLIENT == 'menorayor'
    ) {
      if (this.Lang == 'he-IL') {
        return 'נא להזין מספר עובד';
      } else {
        return 'Please enter an employee number';
      }
    }
    return this.$t('vs.login.placeholder.pid');
  }

  getRecaptcha() {
    return this.$refs.recaptcha as VueRecaptcha;
  }

  async mounted() {
    helper.swalShowLoading();
    let apiResult = await api.CheckElectionDates();
    if (apiResult.ErrorMessage) {
      helper.swalWarning({ text: apiResult.ErrorMessage });
      return;
    }
    this.showMsgWrongDates = apiResult.Response && apiResult.Response.data;
    if (this.showMsgWrongDates) {
      this.msgWrongDates = apiResult.Response!.data;
    }
    helper.close();
  }

  public onVerifyCaptcha(response: string) {
    this.tocken = response;
  }

  async onLoginClick() {
    var username = this.Username;
    if (!username || username.length === 0) {
      helper.swalWarning(this.inputPlaceholder);
      return;
    }
    if (this.ShowCaptcha) {
      if (!this.tocken || this.tocken.length === 0) {
        helper.swalWarning(this.$t('vs.api.error.ConfirmCaptcha'));
        return;
      }
    }

    helper.swalShowLoading();
    var user = await (await api.GetUserInfo(username, this.tocken)).getData();
    if (user?.ErrorCode == 15) {
      var html = '<div>אינך רשאי/ת להצביע בבחירות משום שאינך חבר/ה באגודת הסטודנטים</div><div style=\'font-size: 20px;\'>ההצטרפות לאגודה אינה כרוכה בתשלום</div>' as string;
      var swalResponse = await helper.swalWarning({
        html,
        customClass: {
          content: 'ws-preline',
        },
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'להצטרפות והצבעה לחצ/י כאן',
        confirmButtonAriaLabel: 'Thumbs up, great!',
        cancelButtonText: 'לא מעוניין/ת',
      });
      if (!swalResponse.isConfirmed) {
        return;
      }
      user = await (await api.SetCanVoteAndGetUserData(user.Id)).getData();
    }

    if (this.ShowCaptcha) {
      let el = this.getRecaptcha();
      if (el) el.reset();
    }
    this.tocken = '';
    if (!user) return;
    helper.close();

    var data = {
      Id: user.Id,
      Mobile: user.Mobile,
      Email: user.Email,
    };

    this.$modal.show('login-confirm-code', data);
  }

  async onSendCode(userId: string) {
    helper.swalShowLoading();
    let apiResult = await (await api.ResetPassword(userId)).getData(true, this.codeCheckResponse);
    if (!apiResult) return false;

    var html = this.$t(
      apiResult.Mobile
        ? 'vs.popup.confirmpassword.instructions.general'
        : 'vs.popup.confirmpassword.instructions.email',
    ) as string;
    //html += `\n<button class="btn btn-link btnDidntGetCode">${this.$t('login.popup.confirmpassword.nocode')}</button>`;
    this.CheckCode(html, userId);
    return false;
  }

  async CheckCode(html: string, userId: string) {
    const code = await helper.swalPrompt({
      html,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showCloseButton: true,
      icon: 'info',
    });
    if (code) {
      helper.swalShowLoading();
      let promisse = Q.delay(500);
      var canCheckAgain = true;
      const respRaw = await api.VoterLogin(userId, code);
      const resp = await respRaw.getData(true, (errCode) => (canCheckAgain = this.codeCheckResponse(errCode)));
      if (!resp) {
        if (canCheckAgain) this.CheckCode(html, userId);
        return;
      }
      await api.Init();
      this.$store.commit('Login', resp);
      await promisse;
      this.$router.push({ name: 'Start' });
      await Q.delay(500);
      helper.close();
    }
    this.$modal.hide('login-confirm-code');
  }

  codeCheckResponse(errCode: number | undefined) {
    if (errCode == -1) {
      this.Username = '';
      helper.close();
      this.$modal.hide('login-confirm-code');
      return false;
    }
    return true;
  }
}
